export function formatLeadLineType(lineType?: string | null): string {
  if (!lineType) return '—';
  if (lineType === 'voip') return 'VoIP';
  return lineType.charAt(0).toUpperCase() + lineType.slice(1);
}

export function formatLeadCarrier(
  carrierName?: string | null,
  carrier?: string | null
): string {
  if (carrierName && carrierName.trim()) return carrierName.trim();
  if (!carrier || carrier === 'other') return '—';
  if (carrier === 'att') return 'AT&T';
  if (carrier === 'tmobile') return 'T-Mobile';
  if (carrier === 'verizon') return 'Verizon';
  return carrier;
}

export type LeadLookupPatch = {
  id: string;
  carrier?: string | null;
  carrierName?: string | null;
  lineType?: string | null;
  carrierLookupAt?: string | null;
};

type LeadLookupRow = {
  id: string;
  carrier?: string | null;
  carrierName?: string | null;
  carrier_name?: string | null;
  lineType?: string | null;
  line_type?: string | null;
  carrierLookupAt?: string | null;
  carrier_lookup_at?: string | null;
};

export function normalizeLeadLookupFields<T extends LeadLookupRow>(lead: T): T {
  return {
    ...lead,
    carrier: lead.carrier ?? null,
    carrierName: lead.carrierName ?? lead.carrier_name ?? null,
    lineType: lead.lineType ?? lead.line_type ?? null,
    carrierLookupAt: lead.carrierLookupAt ?? lead.carrier_lookup_at ?? null,
  };
}

export function mergeLeadLookupFields<T extends { id: string }>(
  leads: T[],
  patches: LeadLookupPatch[] | undefined
): T[] {
  if (!patches?.length) return leads;
  const byId = new Map(patches.map((patch) => [patch.id, patch]));
  return leads.map((lead) => {
    const patch = byId.get(lead.id);
    if (!patch) return lead;
    return {
      ...lead,
      carrier: patch.carrier ?? (lead as T & LeadLookupPatch).carrier,
      carrierName: patch.carrierName ?? (lead as T & LeadLookupPatch).carrierName,
      lineType: patch.lineType ?? (lead as T & LeadLookupPatch).lineType,
      carrierLookupAt: patch.carrierLookupAt ?? (lead as T & LeadLookupPatch).carrierLookupAt,
    };
  });
}
